import { useComponentIsMountedRef } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setCtxMenuEvt, setIsDragging } from '../SpreadSheetDataProvider/actions'
import withCellBorderBuilder from './withCellBorderBuilder'

BaseCell = ({
  dataTestid,
  style,
  rowIndex,
  colIndex,
  children,
  isScrolling, #
  isVisible,   # discard these - ie don't put them in child props
  parent,      #
  onMouseDown,
  onMouseMove,
  onMouseUp
  ...rest
}) ->
  [{ selection }, dispatch] = useSpreadSheetData()
  isMounted = useComponentIsMountedRef()

  classNames = withCellBorderBuilder(rowIndex, colIndex)
  throttledMouseMove = _.throttle(onMouseMove or ( -> ), 64) # 15 fps

  ctxMenuHiderFunction = ->
    window.removeEventListener('click', ctxMenuHiderFunction)
    dispatch(setCtxMenuEvt(undefined)) if isMounted.current
    hider = undefined

  openCtxMenu = (event) ->
    event.persist() if event.persist?
    event = event.nativeEvent if event.nativeEvent?
    event.preventDefault()
    event.stopPropagation()
    event.rowIndex = rowIndex
    dispatch(setCtxMenuEvt(event))
    hider = window.addEventListener('click', ctxMenuHiderFunction)

  <div
    className={classNames}
    style={{ style..., cursor: 'pointer' }}
    onMouseDown={(e) ->
      dispatch(setIsDragging(true))
      onMouseDown?(e)
    }
    onMouseUp={(e) ->
      dispatch(setIsDragging(false))
      onMouseUp?(e)
    }
    onMouseMove={throttledMouseMove}
    onContextMenu={openCtxMenu}
    data-testid={dataTestid}
    { ...rest }
  >
    { children }
  </div>

export default BaseCell
